/**
 * DevExtreme (esm/__internal/core/r1/runtime/inferno/create_context.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import _extends from "@babel/runtime/helpers/esm/extends";
import { Component } from "inferno";
let contextId = 0;
export const createContext = function (defaultValue) {
  const id = contextId++;
  return {
    id: id,
    defaultValue: defaultValue,
    Provider: class extends Component {
      getChildContext() {
        return _extends({}, this.context, {
          [id]: this.props.value || defaultValue
        });
      }
      render() {
        return this.props.children;
      }
    }
  };
};